import { ComponentType, forwardRef } from "react";

interface VisibilityProps {
  hidden?: boolean;
}

// Simple HOC to handle the common case of needing to conditionally render a component.
export const withVisibility = <P extends object>(
  WrappedComponent: ComponentType<P>
) => {
  const WithVisibility = forwardRef<any, P & VisibilityProps>((props, ref) => {
    const { hidden, ...rest } = props;

    if (hidden) {
      return null;
    }

    return <WrappedComponent ref={ref} {...(rest as P)} />;
  });

  return WithVisibility;
};
